import { defaultOptions as i } from "./index23.mjs";
import { initReactI18next as e } from "./index42.mjs";
const m = (t, n) => (t.use(e).init({
  ...i,
  ...n
}), {
  i18n: t
});
export {
  m as initI18nInstance
};
